import { Box, SectionHelper, Text } from '@wix/design-system';
import { RuleTipBox, RuleTipItem } from '@wix/rules-panel-ui';
import React from 'react';
import { DOM_ORDER_FIX_OPTION } from './use-dom-order-rule';
export const getRadioOptions = (t, compactPanelChrome) => {
  const showPrefixIcon = compactPanelChrome;
  return [{
    id: DOM_ORDER_FIX_OPTION.AUTO,
    label: t('accessibility-wizard.rules-list.dom-order.radio.auto'),
    optionElement: /*#__PURE__*/React.createElement(RuleTipBox, null, /*#__PURE__*/React.createElement(RuleTipItem, {
      showIcon: false
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin"
    }, t('accessibility-wizard.rules-list.dom-order.radio.auto.note')))),
    value: DOM_ORDER_FIX_OPTION.AUTO
  }, {
    id: DOM_ORDER_FIX_OPTION.MANUAL,
    label: t('accessibility-wizard.rules-list.dom-order.radio.manually'),
    optionElement: /*#__PURE__*/React.createElement(SectionHelper, {
      appearance: "warning",
      showPrefixIcon: showPrefixIcon,
      size: "small"
    }, /*#__PURE__*/React.createElement(Box, {
      padding: "0 4px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin"
    }, t('accessibility-wizard.rules-list.dom-order.radio.manually.note')))),
    value: DOM_ORDER_FIX_OPTION.MANUAL
  }];
};
//# sourceMappingURL=radio-options.js.map